import React from 'react';
import { Button } from 'rsuite';

const ScheduleItem = ({ 
    item, 
    date, 
    canManage, 
    getColorForType, 
    onDragStart, 
    onRemove, 
    showRemoveButton = true,
    isPopover = false 
}) => {
    const getDayTypeLabel = () => {
        const dayType = item.day_type || 'normal';
        if (dayType === 'rest_day') {
            return '休息日';
        } else if (dayType === 'regular_holiday') {
            return '例假日';
        }
        return null;
    };

    const isNationalHoliday = item.is_national_holiday || false;
    const dayTypeLabel = getDayTypeLabel();
    
    // 根據日期類型決定背景顏色
    const getBackgroundColor = () => {
        const dayType = item.day_type || 'normal';
        if (dayType === 'rest_day') {
            return '#ff9800'; // 休息日：橙色
        } else if (dayType === 'regular_holiday') {
            return '#f44336'; // 例假日：紅色
        }
        // 一般工作日使用班別類型的顏色
        return getColorForType(item.type_id);
    };

    return (
        <div style={{ 
            display: 'flex', 
            justifyContent: 'space-between', 
            alignItems: 'center',
            padding: isPopover ? '2px 0' : '0',
            gap: '4px'
        }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '4px', flex: 1, minWidth: 0 }}>
                <span
                    draggable={canManage}
                    onDragStart={(e) => onDragStart(e, item, date)}
                    style={{ 
                        cursor: canManage ? 'move' : 'default',
                        userSelect: 'none',
                        backgroundColor: getBackgroundColor(),
                        color: 'white',
                        padding: '2px 4px',
                        borderRadius: '3px',
                        fontSize: '11px',
                        maxWidth: isPopover ? 'none' : '150px',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap'
                    }}
                    title={`${item.user_name} (${item.type_name}) ${item.time_range}${dayTypeLabel ? ` [${dayTypeLabel}]` : ''}${isNationalHoliday ? ' [國定假日]' : ''}`}
                >
                    {isPopover 
                        ? `${item.user_name} (${item.type_name}) ${item.time_range}` 
                        : `${item.user_name} (${item.type_name})`
                    }
                </span>
                {isNationalHoliday && (
                    <span style={{
                        backgroundColor: '#9c27b0',
                        color: 'white',
                        padding: '1px 4px',
                        borderRadius: '2px',
                        fontSize: '9px',
                        fontWeight: 'bold'
                    }}>
                        國定假日
                    </span>
                )}
            </div>
            {canManage && showRemoveButton && (
                <Button
                    size="xs"
                    color="red"
                    appearance="subtle"
                    onClick={() => onRemove(item.id, date)}
                >
                    {isPopover ? '移除' : '×'}
                </Button>
            )}
        </div>
    );
};

export default ScheduleItem;
